module.exports = __webpack_public_path__ + "media/bootstrap-icons/link-45deg-6cd5bb7a.svg";